import categories from "./categories";

// Build entity-to-route mapping from categories
const entityRoutes = {};

// Special: items → /item/{id}
entityRoutes["items"] = { route: (id) => `/item/${id}`, label: "Ver conteúdo" };

categories.forEach((cat) => {
  if (cat.collection) {
    if (cat.collection === "calculators") {
      entityRoutes[cat.collection] = {
        route: (id) => `/calculators/${id}`,
        label: "Ver calculadora",
      };
    } else {
      entityRoutes[cat.collection] = {
        route: (id) => `/categories/${cat.id}/drugs/${id}`,
        label: "Ver medicamento",
      };
    }
  }

  if (cat.productsCollection) {
    entityRoutes[cat.productsCollection] = {
      route: (id) => `/categories/${cat.id}/products/${id}`,
      label: "Ver produto",
    };
  }
});

// Sort entity names by length descending for greedy matching
const sortedEntities = Object.keys(entityRoutes).sort(
  (a, b) => b.length - a.length
);

/**
 * Transform [VetAlfa:...] citations in markdown to internal links.
 *
 * Input:  [VetAlfa:algivet_veterinary_products.md]
 * Output: [Ver produto](/categories/1/products/algivet)
 */
export function transformCitations(markdown) {
  if (!markdown) return markdown;

  return markdown.replace(/\[VetAlfa:([^\]]+)\]/gi, (match, content) => {
    // Remove .md suffix and trim whitespace
    var cleaned = content.trim().replace(/\.md$/, "").trim();

    // Try matching entity from the end (longest first)
    // Try double-underscore separator first (handles ids where special chars like % became _)
    for (var i = 0; i < sortedEntities.length; i++) {
      var entity = sortedEntities[i];

      if (cleaned.endsWith("__" + entity)) {
        var id = cleaned.slice(0, -(entity.length + 2)).replace(/%/g, "percentage");
        var mapping = entityRoutes[entity];
        return "[" + mapping.label + "](" + mapping.route(id) + ")";
      }
      if (cleaned.endsWith("_" + entity)) {
        var id = cleaned.slice(0, -(entity.length + 1)).replace(/%/g, "percentage");
        var mapping = entityRoutes[entity];
        return "[" + mapping.label + "](" + mapping.route(id) + ")";
      }
    }

    // If no entity match, return original text
    return match;
  });
}
